// extracted by mini-css-extract-plugin
module.exports = {"WithNumberCard":"HeadingImageWithNumberCard_WithNumberCard__Oz7bN"};